<div class="page-header">
  <h1>Our Online Store</h1>
</div>
<div class="online-store">
  <iframe src="https://squareup.com/store/jozo-weider-volunteer-committee" width="100%" height="550" onload="scrolltotop();" type="text/html" frameborder="0">
    Sorry, your browser does not support IFRAMES
  </iframe><
</div>
